<script setup>
import { trans } from '../../../_00_elements/translation';
import { URL_USER_ORGANIZATION_PAYMENT_ACCOUNT } from '../../../_00_elements/tools/routes/routes';

</script>
<template>
  <div class="soon-limited-panel">
    <span class="soon-limited-panel__text">
      {{ trans('gestion.pay.kyc.soon_limited.info') }}
    </span>
    <a class="soon-limited-panel__link" :href="URL_USER_ORGANIZATION_PAYMENT_ACCOUNT">
      {{ trans('gestion.pay.kyc.soon_limited.cta') }}
    </a>
  </div>
</template>
